import {PdfPreviewsCreationStatusApiDto} from "./restModels";

export class PdfPreviewsCreationStatus {
	constructor(public readonly finished: boolean) {
	}

	public static fromJson(json: PdfPreviewsCreationStatusApiDto): PdfPreviewsCreationStatus {
		return new PdfPreviewsCreationStatus(json.finished);
	}
}